import { Form } from 'antd';
import { useState } from 'react';
import { useGetListWorker } from '@/hooks/v2/worker';
import { useCreateWorker } from '@/hooks/v2/worker/useCreateWorker';

interface WorkerProps {
	fieldName?: string | string[];
}

const { useFormInstance, useWatch } = Form;

export function useWorker({ fieldName }: WorkerProps) {
	const form = useFormInstance();
	const [name, setName] = useState<string>('');

	const field = Array.isArray(fieldName) ? fieldName[0] : null;

	const workerId = useWatch(field ? [field, 'worker_list_id'] : 'worker_list_id');
	const organizationId = useWatch(field ? [field, 'organization_id'] : 'organization_id');
	const companyId = useWatch(field ? [field, 'company_id'] : 'company_id');

	const { mutate: createWorker, isLoading: isLoadingCreatingWorker } = useCreateWorker();

	function handleOnChange(id: string): void {
		form.setFieldValue(field ? [field, 'worker_list_id'] : 'worker_list_id', id);
	}

	function handleOnClear(): void {
		form.setFieldValue(field ? [field, 'worker_list_id'] : 'worker_list_id', undefined);
	}

	function handleInputChange(event: React.ChangeEvent<HTMLInputElement>): void {
		setName(event.target.value);
	}

	function addItem(e: React.MouseEvent<HTMLAnchorElement>): void {
		e.preventDefault();

		if (!name.trim() || !organizationId || !companyId) {
			return;
		}

		createWorker({
			name: name.trim(),
			organization_id: organizationId,
			company_id: companyId
		});

		setName('');
	}

	function handleSearch(value: string): void {
		if (value.length > 2) {
			// console.log('value', value);
		}
	}

	const { data: workers, isLoading } = useGetListWorker({
		organization_id: organizationId!,
		company_id: companyId!
	});

	const items =
		workers && workers.rows.length ? workers.rows.map((worker) => ({ label: worker.name, value: worker.id })) : [];

	return {
		name,
		items,
		workerId,
		isLoading,
		isLoadingCreatingWorker,
		addItem,
		handleInputChange,
		handleOnChange,
		handleOnClear,
		handleSearch
	};
}
